import {
  DEFAULT_FISCAL_START,
  fiscalYearBounds,
  fiscalYearOf,
  type FiscalStart,
} from '@myrewards/domain/fiscal';

// The organization's fiscal year on the client (APP-018). Its start comes with Me and the rule is
// the domain's own, so a year worked out here is always the year the server charges. January 1
// until Me says otherwise.

let organizationStart: FiscalStart = DEFAULT_FISCAL_START;

/** Called with each Me (as the time zone is), and by tests. */
export function setOrganizationFiscalStart(start: FiscalStart): void {
  organizationStart = start;
}

/** The fiscal year a business date falls in, named by the year it starts in. */
export function fiscalYearOn(date: string): number {
  return fiscalYearOf(date, organizationStart);
}

/** A fiscal year's first and last days. */
export function fiscalYearDates(year: number): { from: string; to: string } {
  return fiscalYearBounds(year, organizationStart);
}

/**
 * A fiscal year's months in order from its start (APP-018): "2026-07" … "2027-06" for a July 1
 * start, and thirteen when the year starts mid-month (both partial months). A chart over a fiscal
 * year runs over these (RPT3's pace), so a year that crosses New Year reads Jul → Jun, never
 * Jan → Dec.
 */
export function fiscalMonths(year: number): string[] {
  const { from, to } = fiscalYearDates(year);
  const last = to.slice(0, 7);
  const months: string[] = [];
  let y = Number(from.slice(0, 4));
  let m = Number(from.slice(5, 7));
  for (;;) {
    const month = `${String(y)}-${String(m).padStart(2, '0')}`;
    months.push(month);
    if (month >= last) return months;
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
  }
}
